import UserGroupOverViewSubPage from "./usergroup-overview-sub-page";
import UserGroupUsersSubPage    from "./usergroup-users-sub-page";

const UserGroupSubPage = {
    OverView : UserGroupOverViewSubPage,
    Users    : UserGroupUsersSubPage
};

export default UserGroupSubPage;